<!--start::Header-->
<div class="modal-header p-5">
    <div class="d-flex align-items-center w-100">
      <div>
        <!--start::Title-->
        <h3 class="modal-title text-light font-weight-bolder">
          Change password
        </h3>
        <!--end::Title-->
      </div>
      <!--start::Close button-->
      <button type="button" class="btn btn-sm btn-icon btn-icon-lg btn-circle mr-0 ml-auto btn-ecam-primary" aria-label="Close" (click)="modal.dismiss()">
        <mat-icon color="accent" matSuffix>close</mat-icon>
      </button>
      <!--end::Close button-->
    </div>
  </div>
  <!--end::Header-->
  <!--start::Body-->
  <div class="overlay overlay-block cursor-default modal-body m-5">
    <div class="mat-table__message" *ngIf="isLoading">
      <span [ngClass]="{
          'spinner spinner-primary spinner-track spinner-lg': isLoading
        }"></span>
    </div>
    <ng-container *ngIf="!isLoading">
      <form [formGroup]="passwordForm" class="form form-label-right" *ngIf="!isLoading">
        <div class="form-group row">
            <div class="col-lg-12 mb-1">
                <label>Current Password*</label>
                <mat-form-field class="mat-form-field-fluid" appearance="outline">
                  <input matInput [type]="hideCurrentPassword ? 'password' : 'text'" formControlName="currentPassword"
                         placeholder="Current Password" />
                  <mat-icon matSuffix (click)="hideCurrentPassword = !hideCurrentPassword">
                    {{
                        hideCurrentPassword ? "visibility_off" : "visibility"
                    }}
                  </mat-icon>
                  <mat-error *ngIf="passwordForm.hasError('required', 'currentPassword')">
                    Current password is <strong>required</strong>
                  </mat-error>
                </mat-form-field>
              </div>
          <div class="col-lg-12 mb-1">
            <label>New Password*</label>
            <mat-form-field class="mat-form-field-fluid" appearance="outline">
              <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password"
                     placeholder="New Password" [errorStateMatcher]="passwordFormErrorStateMatcher" />
              <mat-icon matSuffix (click)="hidePassword = !hidePassword">
                {{
                hidePassword ? "visibility_off" : "visibility"
                }}
              </mat-icon>
              <mat-error *ngIf="passwordForm.hasError('required', 'password')">
                New Password is <strong>required</strong>
              </mat-error>
              <mat-error *ngIf="passwordForm.hasError('maxlength', 'password') && !passwordForm.hasError('required', 'password')">
                New Password cannot exceed 30 characters
              </mat-error>
              <mat-error *ngIf="passwordForm.hasError('requireLength', 'password') && !passwordForm.hasError('required', 'password') && !passwordForm.hasError('maxlength', 'password')">
                New Password must contain at least {{passwordComplexitySetting.requiredLength}} characters
              </mat-error>
              <mat-error *ngIf="passwordForm.hasError('requireUppercase', 'password') && !passwordForm.hasError('required', 'password') && !passwordForm.hasError('maxlength', 'password')">
                New Password must contain at least uppercase letter
              </mat-error>
              <mat-error *ngIf="passwordForm.hasError('requireLowercase', 'password') && !passwordForm.hasError('required', 'password') && !passwordForm.hasError('maxlength', 'password')">
                New Password must contain at least lowercase letter
              </mat-error>
              <mat-error *ngIf="passwordForm.hasError('requireDigit', 'password') && !passwordForm.hasError('required', 'password') && !passwordForm.hasError('maxlength', 'password')">
                New Password must contain at least one number
              </mat-error>
              <mat-error *ngIf="passwordForm.hasError('requireSpecialCharacter', 'password') && !passwordForm.hasError('required', 'password') && !passwordForm.hasError('maxlength', 'password')">
                New Password must contain at least one special character (!@#$%^&*,.)
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-12 mb-1">
            <label>Confirm New password*</label>
            <mat-form-field class="mat-form-field-fluid" appearance="outline">
              <input matInput [type]="hideResetPassword ? 'password' : 'text'" formControlName="confirmPassword"
                     placeholder="Confirm New Password" [errorStateMatcher]="passwordFormErrorStateMatcher" />
              <mat-icon matSuffix (click)="hideResetPassword = !hideResetPassword">
                {{
                hideResetPassword ? "visibility_off" : "visibility"
                }}
              </mat-icon>
              <mat-error *ngIf="passwordForm.hasError('required', 'confirmPassword')">
                Confirm New Password is <strong>required</strong>
              </mat-error>
              <mat-error *ngIf="passwordForm.hasError('mismatch', 'confirmPassword') && !passwordForm.hasError('required', 'confirmPassword')">
                Passwords do not match
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </form>
    </ng-container>
  </div>
  <!--end::Body-->
  <!--start::Footer-->
  <div class="modal-footer w-100" *ngIf="!isLoading">
    <button type="button" class="btn btn-pill btn-light px-11 mr-1" (click)="modal.dismiss()" [disabled]="saving">
      Cancel
    </button>&nbsp;
    <button type="button" class="btn btn-pill btn-primary text-dark px-12" (click)="save()" [disabled]="!(passwordForm.valid && (passwordForm.touched || passwordForm.dirty)) || saving" [ngClass]="{'spinner spinner-white spinner-right' : saving}">
      Save
    </button>
  </div>
  <!--start::Footer-->
  